/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { createDialogRoute, FormState, FormStateBuilder, NumberTypes } from '@gh/common-shared';
import { DialogInput, FormMode, validationError } from '@gh/core-ui';
import { isNil } from 'lodash';
import { nullate } from '@gh/core-util';
import { ReportRohcMasterCc } from '../../../resources/report-roch-details.model';

export type ReportRohcMasterCcDialogConfig = {
  isCreateMode: boolean;
  masterCc: ReportRohcMasterCc;
  isCodeUnique: PredicateFn<number>;
};

@Component({
  selector: 'gh-report-rohc-master-cc-dialog',
  template: require('./report-rohc-master-cc-dialog.component.html'),
  styles: [require('./report-rohc-master-cc-dialog.component.scss')],
})
export class ReportRohcMasterCcDialogComponent implements OnInit, DialogInput<ReportRohcMasterCcDialogConfig> {
  input: ReportRohcMasterCcDialogConfig;

  form: FormState<ReportRohcMasterCc>;

  get title(): string {
    return this.form.createMode ? 'lbl_create_master_cc' : 'lbl_edit_master_cc';
  }

  constructor(private dialogRef: MatDialogRef<any>,
              private formStateBuilder: FormStateBuilder) {
  }

  ngOnInit(): void {
    const { masterCc } = this.input;
    this.form = this.formStateBuilder.buildPlain({
      value: masterCc,
      mode: this.input.isCreateMode ? FormMode.CreateMode : FormMode.EditMode,
      children: {
        id: void 0,
        code: {
          required: true,
          type: NumberTypes.Code,
          validators: [
            ({ value }: AbstractControl) =>
              (isNil(value) || value === masterCc.code || this.input.isCodeUnique(value)) ?
                nullate(void 0) : { code: validationError('msg_cc_number_not_unique') },
          ],
        },
        name: { required: true },
        dirtyType: void 0,
        version: void 0,
      },
    });
  }

  onSave(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.dialogRef.close(this.form.submitValue);
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}

export const reportRohcMasterCcDialogRoute = createDialogRoute({
  component: ReportRohcMasterCcDialogComponent,
});
